import PropTypes from 'prop-types';
import React from 'react';
import sAction from 'sAction';

export default function FileName(props) {
    const showEye = true;
    let showDownload = true;
    let showName = true;
    let lineRender = null;
    let showDownloadBtn = false;
    let fileName = props.value;

    // get file size from hidden row in list view
    const rowsData = sAction.dataGet(props.prefix + '/rows');
    const fileSizeRecord = rowsData.find((row) => row.get('key') === 'FILE_SIZE');
    let fileSize = 0;
    if (fileSizeRecord) {
        fileSize = fileSizeRecord.get('records').get(props.index).get('value');
    }

    let id = null;
    if (fileName.includes('::')) {
        id = fileName.split('::')[0];
        fileName = fileName.split('::')[1];
    }
    lineRender = <a
        title={fileName}
        onClick={(e) => {
            props.onGetFile({id: id, module: props.module, name: fileName, documentId: props.id});
        }}>
        {fileName}
    </a>;

    let getRowsData = sAction.dataGet(props.prefix + '/rows');
    if (getRowsData) getRowsData = getRowsData.toJS();

    if (props?.isWidget) {
        showDownloadBtn = true;
        showName = false;
        showDownload = false;
    }

    let className = 'newListViewLine';
    if (props.extraClass !== undefined) {
        className += ' '+props.extraClass;
    }

    const getPreviewBtn = (action, className = '') => {
        return (
            <div className={'listDownloadBtn previewBtn ' + className}
                onClick={action}>
                <span className="iconfa-eye"></span>
                {sAction.translate('LBL_VIEW_FILE')}
            </div>
        );
    };

    let showImage = getPreviewBtn(() => {}, 'inactive');
    const downloadFileFn = (e) => {
        props.onGetFile({id: id, module: props.module, name: fileName, documentId: props.id});
    };

    // console.log('FileName', props);

    if (/\.(bmp|jpg|jpeg|png|gif|svg|webp|ico)$/i.test(props.value)) {
        if (props.module === 'Notes') {
            showImage = getPreviewBtn(() => sAction.openRightPanel('image', {
                name: props.value,
                url: sAction.param.files + 'notes_image/' + props.data.id,
                downloadFn: downloadFileFn,
                module: props.module,
                id: props.id,
            }));
        } else {
            showImage = getPreviewBtn(() => sAction.openRightPanel('image', {
                name: props.value,
                url: sAction.param.files + 'image/'+ props.id,
                downloadFn: downloadFileFn,
                module: props.module,
                id: props.id,
            }));
        }
    } else if (/\.(pdf)$/i.test(props.value)) {
        showImage = getPreviewBtn(() => sAction.filePreview(props.id, props.module, props.value, 'pdf', downloadFileFn));
    } else if (/\.(mp4)$/i.test(props.value)) {
        showImage = getPreviewBtn(() => sAction.filePreview(props.id, props.module, props.value, 'mp4', downloadFileFn));
    } else if (/\.(docx)$/i.test(props.value)) {
        showImage = getPreviewBtn(() => sAction.filePreview(props.id, props.module, props.value, 'docx', downloadFileFn));
    } else if (/\.(xlsx|xls)$/i.test(props.value)) {
        showImage = getPreviewBtn(() => sAction.filePreview(props.id, props.module, props.value, 'xlsx', downloadFileFn));
    }

    let download = <div onClick={(e) => {
        props.onGetFile({id: id, module: props.module, name: fileName, documentId: props.id});
    }} className="icon-downloadPortal listDownLoadIcon"></div>;
    if (props.module === 'Notes' && props.value === '____') {
        download = <div className="icon-downloadPortal listDownLoadIcon inactive notAllowedClass"></div>;
    }

    const fileNameSplit = fileName.split('.');
    const fileType = fileNameSplit[fileNameSplit.length - 1];
    const downloadBtn = <div onClick={(e) => {
        props.onGetFile({id: id, module: props.module, name: fileName, documentId: props.id});
    }}
    className="listDownloadBtn">
        <span className="icon-download"></span>
        {sAction.translate('LBL_DOWNLOAD_FILE')}
        <span className='downloadBtnLabel'>({sAction.convertFileSize(fileSize)} / {fileType})</span>
    </div>;

    return (
        <div className={className + ' fileDownloadField'}>
            {showEye && showImage}
            {showDownloadBtn && downloadBtn}
            {showName && lineRender}
            {showDownload && download}
        </div>
    );
}

FileName.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.any,
    }),
    extraClass: PropTypes.any,
    id: PropTypes.any,
    module: PropTypes.string,
    onGetFile: PropTypes.func,
    value: PropTypes.string,
    isWidget: PropTypes.bool,
    prefix: PropTypes.string,
    index: PropTypes.number,
};
